import React, {useState} from 'react';
import DataTable from '../../components/DataTable/DataTable';
import MaintenanceModal from '../../components/MarkerModals/MaintenanceModal/MaintenanceModal';
import LCRadarChart from '../../components/Charts/LCRadarChart/LCRadarChart';
import LCLineChart from '../../components/Charts/LCLineChart/LCLineChart';
import LCBarChart from '../../components/Charts/LCBarChart/LCBarChart';
import LCPieChart from '../../components/Charts/LCPieChart/LCPieChart';
import Filter from '../../components/Filter/Filter';
import dayjs from 'dayjs';
import { useMaintenance } from '../../hooks/preventiveMaintenance';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';


const dataColumns = [
    { label: "Α/Α", key: "serialNumber" },
    { label: "Ημερομηνία Αναγγελίας Βλάβης", key: "submissionDate" },
    { label: "Τύπος Αναφοράς", key: "maintenanceType" },
    { label: "Τύπος Εξοπλισμού", key: "deviceType" },
    { label: "ID Εξοπλισμού", key: "deviceId" },
    { label: "Νομός", key: "county" },
    { label: "Περιοχή", key: "area" },
    { label: "Ημερομηνία Συντήρησης/Βλάβης", key: "damageDate" },
    { label: "Αναφορά Βλάβης", key: "reportedFrom" },
    { label: "Κατάσταση Βλάβης", key: "reportedFromDetails" },
    { label: "Ημερομηνία Ανάληψης Βλάβης", key: "createdAt" },
    { label: "Προτεραιότητα", key: "priority" },
    { label: "Υπαιτιότητα", key: "responsibilityOf" },
    { label: "Ημερομηνία Αποκατάστασης/Συντήρησης", key: "restorationDate" },
    { label: "Κατάσταση", key: "status" },

];


const PreventiveMaintenance = () => {
    const [filters, setFilters] = useState({
        fromDate: dayjs().add(-1, "day"),
        toDate: dayjs().add(1, "day"),
      });

    const [modalOpen, setModalOpen] = useState(false);
    
    const {dataForGraphs, dataForTable, handleSearchClick, handleRowClick, handleCloseModal, selectedRow} = useMaintenance(filters, setModalOpen);


    return (
        <>
           <Grid container spacing={4}>
                <Grid size={{ xs: 6, md: 6 }}>
                    <Filter filters = {filters} setFilters={setFilters} deviceStateFilters = {false}  onSearch={handleSearchClick}/>
                </Grid>
                <Grid size={{ xs: 6, md: 6 }}>
                <LCPieChart data={dataForGraphs?.overallCountsByResponsibility ?? []} />
                </Grid>
           </Grid>
           
           <LCLineChart data={dataForGraphs?.dailyCountsByResponsibility ?? []} xaxisLabel={"date"}/>
           
           <LCBarChart data={dataForGraphs?.resolutionTimes ?? []} xaxisLabel={"Αναγνωριστικό Συσκευής"}/>


           <LCLineChart data={dataForGraphs?.deviceIncidentCounts ?? []} xaxisLabel={"deviceId"}/>

           


           <Grid container spacing={4}>
                <Grid size={{ xs: 6, md: 6 }}>
                    <LCBarChart data={dataForGraphs?.reportedFromCounts ?? []} xaxisLabel={"source"}/>
                </Grid>
                <Grid size={{ xs: 6, md: 6 }}>
                    <LCBarChart data={dataForGraphs?.statusCounts ?? []} xaxisLabel={"status"}/>
                </Grid>
           </Grid>

           <Grid container spacing={4}>
                <Grid size={{ xs: 6, md: 6 }}>
                    <LCPieChart data={dataForGraphs?.deviceTypeCounts ?? []}/>
                </Grid>
                <Grid size={{ xs: 6, md: 6 }}>
                    <LCRadarChart data={dataForGraphs?.countyCounts ?? []}/>
                </Grid>
           </Grid>
           
           <Card>
            <CardHeader>
                <Typography>Λίστα αναφορών</Typography>
            </CardHeader>

            <Button variant="contained" sx={{ mb: 1 }}>
              Νέα αναφορά
            </Button>
           </Card>

           <DataTable columns = {dataColumns} data = {dataForTable} onRowClick={handleRowClick}/>
           <MaintenanceModal open ={modalOpen} maintenanceReference = {selectedRow} onClose={handleCloseModal} />
        </>
    );
};

export default PreventiveMaintenance;